
import { defineComponent } from "vue";

export default defineComponent({
  name: "AppFooter",
  data() {
    return {
      role: "",
      items: [
        "City: Cebu City",
        "Zip Code: 6000",
        "Phone Number: (032)3333333",
        "Mobile Number: 09916588874",
      ] as string[],
    };
  },
});
